/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Response model for finalizing a video upload.  Attributes:     videoId (str): The ID of the video to finalize.     status (str): The status of the upload finalization.
 */
export interface FinalizeUploadDTO { 
    videoId: string;
    status: string;
    message: string;
}

